import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SEND_EMAIL_COMMUNICATION, SEND_EMAIL_COMMUNICATION_SUCCESS, SEND_EMAIL_COMMUNICATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* sendEmailCommunication({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    // const { clientId, programId, userId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/email-reply`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: SEND_EMAIL_COMMUNICATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: SEND_EMAIL_COMMUNICATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SEND_EMAIL_COMMUNICATION_ERROR, payload: error });
  }
}

export function* watchSendEmailCommunication() {
  yield takeEvery(SEND_EMAIL_COMMUNICATION, sendEmailCommunication);
}

function* sendEmailCommunicationSaga() {
  yield all([fork(watchSendEmailCommunication)]);
}

export default sendEmailCommunicationSaga;
